import { InjectionToken } from '@angular/core';

export const ENV_VARS = new InjectionToken('ENV_VARS', {
  providedIn: 'root',
  factory: () => {}
});
